import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { SwitchOnProvider } from './SwitchOnProvider/SwitchOnProvider';
import { Introduction } from './Panels/Introduction/Introduction';
import { ApplicationComplete } from './ApplicationComplete/ApplicationComplete';
import { Loading } from './Loading/Loading';
import { LoadError } from './LoadError/LoadError';

import { useGetCarFinanceInitialFormData } from '../../../components/CarFinancePage/queries/hooks/useGetCarFinanceInitialFormData';

import { QueryParameters } from '../../../components/CarFinancePage/queries/schema/carFinance.schema';

import { media } from '../../../helpers/breakpoints';
import { onSubmitTrackingEvent } from '../financeProviders/shared/tracking/tracking';
import { setStartTime } from '../../../helpers/browserStorageTimer';
import { FINANCE_APPLICATION_START_TIME } from '../constants';
import { RESULT } from '../financeProviders/shared/tracking/tracking.typed';
import { PanelProvider } from '../financeProviders/shared/PanelContext';

const Wrapper = styled.div`
  padding: ${({ theme }) => `${theme.spacing.S8} 0`};
  max-width: 760px;
  min-height: 720px;

  ${media.medium} {
    padding: ${({ theme }) => `${theme.spacing.M24} 0`};
  }
`;

const CarFinancePage = (props: { query: QueryParameters }) => {
  const { query } = props;
  const { adId, make, model, price, provider } = query;

  const {
    isPending: initialFormDataPending,
    data: initialFormData,
    isError: initialFormDataError,
  } = useGetCarFinanceInitialFormData(query);

  const [isSubmissionSuccessful, setIsSubmissionSuccessful] = useState(false);

  const updateToSuccessState = () => {
    onSubmitTrackingEvent({ result: RESULT.SUCCESS, provider });
    setIsSubmissionSuccessful(true);
  };

  const onSubmitErrorCallback = (errorFields: Array<string>) => {
    onSubmitTrackingEvent({
      result: RESULT.FAILURE,
      provider,
      errorFields,
    });
  };

  useEffect(() => {
    if (
      !localStorage.getItem(FINANCE_APPLICATION_START_TIME) &&
      !sessionStorage.getItem(FINANCE_APPLICATION_START_TIME)
    ) {
      setStartTime(
        FINANCE_APPLICATION_START_TIME,
        new Date().getTime().toString(),
      );
    }
  }, []);

  return (
    <Wrapper className="row">
      <div className="small-12">
        {!isSubmissionSuccessful && (
          <>
            {!initialFormDataPending && initialFormData && (
              <>
                <Introduction
                  adId={adId}
                  make={make}
                  model={model}
                  provider={provider}
                  price={price}
                />
                <PanelProvider>
                  <SwitchOnProvider
                    query={query}
                    onSubmitCallback={updateToSuccessState}
                    onSubmitErrorCallback={onSubmitErrorCallback}
                    initialFormData={initialFormData}
                  />
                </PanelProvider>
              </>
            )}
            {!initialFormDataPending && initialFormDataError && <LoadError />}
            {initialFormDataPending && <Loading />}
          </>
        )}
        {isSubmissionSuccessful && <ApplicationComplete />}
      </div>
    </Wrapper>
  );
};

export { CarFinancePage };
